import React from 'react'
import { classNames } from 'src/lib/utils/helpers'

interface NewInputTextFieldProps {
  isDisabled?: boolean
  textFieldId: string
  inputValue?: any
  handleChange?: (value: any) => void
  inputType: string
  errorStatus?: boolean
  errorMessage?: string
  label?: React.ReactNode
  bottomDescription?: string
  inputPlaceholder?: string
  customClass?: string
}

const InputTextFieldV2: React.FC<NewInputTextFieldProps> = ({
  isDisabled = false,
  textFieldId,
  inputValue,
  handleChange,
  inputType = 'text',
  errorStatus = false,
  errorMessage = '',
  label = '',
  bottomDescription = '',
  inputPlaceholder = '',
  customClass
}) => {
  return (
    <div className='flex flex-col gap-2'>
      <div className={customClass}>
        {label}
        <input
          disabled={isDisabled}
          id={textFieldId}
          placeholder={inputPlaceholder}
          className={classNames(
            'px-2 py-2 border rounded-lg focus:border-primary-dark [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none',
            isDisabled ? 'text-gray-dark' : ''
          )}
          type={inputType}
          value={inputValue}
          onChange={handleChange}
          onKeyDown={e => {
            if (inputType === 'number' && (e.key === 'ArrowUp' || e.key === 'ArrowDown')) {
              e.preventDefault() // prevents keyboard increment
            }
          }}
          onWheel={e => {
            if (inputType === 'number') {
              e.currentTarget.blur()
            }
          }}
        />
        {errorStatus && <p className='text-xs text-red-dark font p-2 font-medium'>{errorMessage}</p>}
      </div>
      <p className='text-sm text-gray-dark'>{bottomDescription}</p>
    </div>
  )
}

export default InputTextFieldV2
